import {
  confirmOrDeclineBooking as publicConfirmOrDeclineBooking,
  bulkConfirmOrDeclineBooking as publicBulkConfirmOrDeclineBooking,
  bookingsCancelBookingAnonymously as publicBookingsCancelBookingAnonymously,
  bookingsRescheduleBookingAnonymously as publicBookingsRescheduleBookingAnonymously,
  bookingsGetBookingAnonymously as publicBookingsGetBookingAnonymously,
  getServiceAnonymously as publicGetServiceAnonymously,
  getAnonymousActionToken as publicGetAnonymousActionToken,
  createMultiServiceBooking as publicCreateMultiServiceBooking,
  rescheduleMultiServiceBooking as publicRescheduleMultiServiceBooking,
  getMultiServiceBookingAvailability as publicGetMultiServiceBookingAvailability,
  cancelMultiServiceBooking as publicCancelMultiServiceBooking,
  markMultiServiceBookingAsPending as publicMarkMultiServiceBookingAsPending,
  confirmMultiServiceBooking as publicConfirmMultiServiceBooking,
  declineMultiServiceBooking as publicDeclineMultiServiceBooking,
  bulkGetMultiServiceBookingAllowedActions as publicBulkGetMultiServiceBookingAllowedActions,
  getMultiServiceBooking as publicGetMultiServiceBooking,
  addBookingsToMultiServiceBooking as publicAddBookingsToMultiServiceBooking,
  removeBookingsFromMultiServiceBooking as publicRemoveBookingsFromMultiServiceBooking,
  createBooking as publicCreateBooking,
  bulkCreateBooking as publicBulkCreateBooking,
  rescheduleBooking as publicRescheduleBooking,
  confirmBooking as publicConfirmBooking,
  setBookingSubmissionId as publicSetBookingSubmissionId,
  updateExtendedFields as publicUpdateExtendedFields,
  declineBooking as publicDeclineBooking,
  cancelBooking as publicCancelBooking,
  updateNumberOfParticipants as publicUpdateNumberOfParticipants,
  bulkCalculateAllowedActions as publicBulkCalculateAllowedActions,
  markBookingAsPending as publicMarkBookingAsPending,
} from './bookings-v2-booking-bookings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onBookingCanceled as publicOnBookingCanceled } from './bookings-v2-booking-bookings.public.js';
import { onBookingConfirmed as publicOnBookingConfirmed } from './bookings-v2-booking-bookings.public.js';
import { onBookingCreated as publicOnBookingCreated } from './bookings-v2-booking-bookings.public.js';
import { onBookingDeclined as publicOnBookingDeclined } from './bookings-v2-booking-bookings.public.js';
import { onBookingRescheduled as publicOnBookingRescheduled } from './bookings-v2-booking-bookings.public.js';
import { onBookingUpdated as publicOnBookingUpdated } from './bookings-v2-booking-bookings.public.js';
import { onBookingMarkedAsPending as publicOnBookingMarkedAsPending } from './bookings-v2-booking-bookings.public.js';
import { onBookingNumberOfParticipantsUpdated as publicOnBookingNumberOfParticipantsUpdated } from './bookings-v2-booking-bookings.public.js';

export const confirmOrDeclineBooking: MaybeContext<
  BuildRESTFunction<typeof publicConfirmOrDeclineBooking> &
    typeof publicConfirmOrDeclineBooking
> = /*#__PURE__*/ createRESTModule(publicConfirmOrDeclineBooking);
export const bulkConfirmOrDeclineBooking: MaybeContext<
  BuildRESTFunction<typeof publicBulkConfirmOrDeclineBooking> &
    typeof publicBulkConfirmOrDeclineBooking
> = /*#__PURE__*/ createRESTModule(publicBulkConfirmOrDeclineBooking);
export const bookingsCancelBookingAnonymously: MaybeContext<
  BuildRESTFunction<typeof publicBookingsCancelBookingAnonymously> &
    typeof publicBookingsCancelBookingAnonymously
> = /*#__PURE__*/ createRESTModule(publicBookingsCancelBookingAnonymously);
export const bookingsRescheduleBookingAnonymously: MaybeContext<
  BuildRESTFunction<typeof publicBookingsRescheduleBookingAnonymously> &
    typeof publicBookingsRescheduleBookingAnonymously
> = /*#__PURE__*/ createRESTModule(publicBookingsRescheduleBookingAnonymously);
export const bookingsGetBookingAnonymously: MaybeContext<
  BuildRESTFunction<typeof publicBookingsGetBookingAnonymously> &
    typeof publicBookingsGetBookingAnonymously
> = /*#__PURE__*/ createRESTModule(publicBookingsGetBookingAnonymously);
export const getServiceAnonymously: MaybeContext<
  BuildRESTFunction<typeof publicGetServiceAnonymously> &
    typeof publicGetServiceAnonymously
> = /*#__PURE__*/ createRESTModule(publicGetServiceAnonymously);
export const getAnonymousActionToken: MaybeContext<
  BuildRESTFunction<typeof publicGetAnonymousActionToken> &
    typeof publicGetAnonymousActionToken
> = /*#__PURE__*/ createRESTModule(publicGetAnonymousActionToken);
export const createMultiServiceBooking: MaybeContext<
  BuildRESTFunction<typeof publicCreateMultiServiceBooking> &
    typeof publicCreateMultiServiceBooking
> = /*#__PURE__*/ createRESTModule(publicCreateMultiServiceBooking);
export const rescheduleMultiServiceBooking: MaybeContext<
  BuildRESTFunction<typeof publicRescheduleMultiServiceBooking> &
    typeof publicRescheduleMultiServiceBooking
> = /*#__PURE__*/ createRESTModule(publicRescheduleMultiServiceBooking);
export const getMultiServiceBookingAvailability: MaybeContext<
  BuildRESTFunction<typeof publicGetMultiServiceBookingAvailability> &
    typeof publicGetMultiServiceBookingAvailability
> = /*#__PURE__*/ createRESTModule(publicGetMultiServiceBookingAvailability);
export const cancelMultiServiceBooking: MaybeContext<
  BuildRESTFunction<typeof publicCancelMultiServiceBooking> &
    typeof publicCancelMultiServiceBooking
> = /*#__PURE__*/ createRESTModule(publicCancelMultiServiceBooking);
export const markMultiServiceBookingAsPending: MaybeContext<
  BuildRESTFunction<typeof publicMarkMultiServiceBookingAsPending> &
    typeof publicMarkMultiServiceBookingAsPending
> = /*#__PURE__*/ createRESTModule(publicMarkMultiServiceBookingAsPending);
export const confirmMultiServiceBooking: MaybeContext<
  BuildRESTFunction<typeof publicConfirmMultiServiceBooking> &
    typeof publicConfirmMultiServiceBooking
> = /*#__PURE__*/ createRESTModule(publicConfirmMultiServiceBooking);
export const declineMultiServiceBooking: MaybeContext<
  BuildRESTFunction<typeof publicDeclineMultiServiceBooking> &
    typeof publicDeclineMultiServiceBooking
> = /*#__PURE__*/ createRESTModule(publicDeclineMultiServiceBooking);
export const bulkGetMultiServiceBookingAllowedActions: MaybeContext<
  BuildRESTFunction<typeof publicBulkGetMultiServiceBookingAllowedActions> &
    typeof publicBulkGetMultiServiceBookingAllowedActions
> = /*#__PURE__*/ createRESTModule(
  publicBulkGetMultiServiceBookingAllowedActions
);
export const getMultiServiceBooking: MaybeContext<
  BuildRESTFunction<typeof publicGetMultiServiceBooking> &
    typeof publicGetMultiServiceBooking
> = /*#__PURE__*/ createRESTModule(publicGetMultiServiceBooking);
export const addBookingsToMultiServiceBooking: MaybeContext<
  BuildRESTFunction<typeof publicAddBookingsToMultiServiceBooking> &
    typeof publicAddBookingsToMultiServiceBooking
> = /*#__PURE__*/ createRESTModule(publicAddBookingsToMultiServiceBooking);
export const removeBookingsFromMultiServiceBooking: MaybeContext<
  BuildRESTFunction<typeof publicRemoveBookingsFromMultiServiceBooking> &
    typeof publicRemoveBookingsFromMultiServiceBooking
> = /*#__PURE__*/ createRESTModule(publicRemoveBookingsFromMultiServiceBooking);
export const createBooking: MaybeContext<
  BuildRESTFunction<typeof publicCreateBooking> & typeof publicCreateBooking
> = /*#__PURE__*/ createRESTModule(publicCreateBooking);
export const bulkCreateBooking: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateBooking> &
    typeof publicBulkCreateBooking
> = /*#__PURE__*/ createRESTModule(publicBulkCreateBooking);
export const rescheduleBooking: MaybeContext<
  BuildRESTFunction<typeof publicRescheduleBooking> &
    typeof publicRescheduleBooking
> = /*#__PURE__*/ createRESTModule(publicRescheduleBooking);
export const confirmBooking: MaybeContext<
  BuildRESTFunction<typeof publicConfirmBooking> & typeof publicConfirmBooking
> = /*#__PURE__*/ createRESTModule(publicConfirmBooking);
export const setBookingSubmissionId: MaybeContext<
  BuildRESTFunction<typeof publicSetBookingSubmissionId> &
    typeof publicSetBookingSubmissionId
> = /*#__PURE__*/ createRESTModule(publicSetBookingSubmissionId);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const declineBooking: MaybeContext<
  BuildRESTFunction<typeof publicDeclineBooking> & typeof publicDeclineBooking
> = /*#__PURE__*/ createRESTModule(publicDeclineBooking);
export const cancelBooking: MaybeContext<
  BuildRESTFunction<typeof publicCancelBooking> & typeof publicCancelBooking
> = /*#__PURE__*/ createRESTModule(publicCancelBooking);
export const updateNumberOfParticipants: MaybeContext<
  BuildRESTFunction<typeof publicUpdateNumberOfParticipants> &
    typeof publicUpdateNumberOfParticipants
> = /*#__PURE__*/ createRESTModule(publicUpdateNumberOfParticipants);
export const bulkCalculateAllowedActions: MaybeContext<
  BuildRESTFunction<typeof publicBulkCalculateAllowedActions> &
    typeof publicBulkCalculateAllowedActions
> = /*#__PURE__*/ createRESTModule(publicBulkCalculateAllowedActions);
export const markBookingAsPending: MaybeContext<
  BuildRESTFunction<typeof publicMarkBookingAsPending> &
    typeof publicMarkBookingAsPending
> = /*#__PURE__*/ createRESTModule(publicMarkBookingAsPending);
/**
 * Triggered when a booking is canceled.
 */
export const onBookingCanceled: BuildEventDefinition<
  typeof publicOnBookingCanceled
> &
  typeof publicOnBookingCanceled = createEventModule(publicOnBookingCanceled);
/**
 * Triggered when a booking is confirmed.
 */
export const onBookingConfirmed: BuildEventDefinition<
  typeof publicOnBookingConfirmed
> &
  typeof publicOnBookingConfirmed = createEventModule(publicOnBookingConfirmed);
/**
 * Triggered when a booking is created.
 */
export const onBookingCreated: BuildEventDefinition<
  typeof publicOnBookingCreated
> &
  typeof publicOnBookingCreated = createEventModule(publicOnBookingCreated);
/**
 * Triggered when a booking is declined.
 */
export const onBookingDeclined: BuildEventDefinition<
  typeof publicOnBookingDeclined
> &
  typeof publicOnBookingDeclined = createEventModule(publicOnBookingDeclined);
/**
 * Triggered when a booking is rescheduled.
 */
export const onBookingRescheduled: BuildEventDefinition<
  typeof publicOnBookingRescheduled
> &
  typeof publicOnBookingRescheduled = createEventModule(
  publicOnBookingRescheduled
);
/**
 * Triggered when a booked schedule is updated.
 */
export const onBookingUpdated: BuildEventDefinition<
  typeof publicOnBookingUpdated
> &
  typeof publicOnBookingUpdated = createEventModule(publicOnBookingUpdated);
/**
 * Triggered when a booking is marked as pending.
 */
export const onBookingMarkedAsPending: BuildEventDefinition<
  typeof publicOnBookingMarkedAsPending
> &
  typeof publicOnBookingMarkedAsPending = createEventModule(
  publicOnBookingMarkedAsPending
);
/**
 * Triggered when the number of participants is updated.
 */
export const onBookingNumberOfParticipantsUpdated: BuildEventDefinition<
  typeof publicOnBookingNumberOfParticipantsUpdated
> &
  typeof publicOnBookingNumberOfParticipantsUpdated = createEventModule(
  publicOnBookingNumberOfParticipantsUpdated
);

export {
  MultiServiceBookingType,
  ResourceTransparency,
  LocationType,
  SelectionMethod,
  ValueType,
  BookingStatus,
  PaymentStatus,
  SelectedPaymentOption,
  Platform,
  Actor,
  IdentificationDataIdentityType,
  WebhookIdentityType,
  LocationLocationType,
  V1RequestedFields,
  BookingFeeStatus,
  Trigger,
  RequestedFields,
  ServiceType,
  RateType,
  FrequencyType,
  FirstChargeDateType,
  AddOnPaymentOptions,
  LocationTypeEnumLocationType,
  RankingOrder,
  SortingMethodType,
  Timing,
  CompletionRequirement,
  UnitType,
  TaxableAddressType,
  IdentityType,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  Interval,
  NestedAggregationType,
  AggregationType,
  Mode,
} from './bookings-v2-booking-bookings.universal.js';
export {
  Booking,
  BookingParticipantsInfoOneOf,
  BookedEntity,
  BookedEntityItemOneOf,
  BookedSlot,
  BookedResource,
  Location,
  V2PhoneCall,
  ResourceSelection,
  BookedSchedule,
  ContactDetails,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  CustomFormField,
  BookingSource,
  ParticipantNotification,
  CommonIdentificationData,
  CommonIdentificationDataIdOneOf,
  FlowControlSettings,
  ExtendedFields,
  ParticipantChoices,
  ServiceChoices,
  ServiceChoice,
  ServiceChoiceChoiceOneOf,
  Duration,
  MultiServiceBookingInfo,
  BookedAddOn,
  BookingFormFilled,
  V2CreateBookingRequest,
  V2CreateBookingRequestBookableItemOneOf,
  V2CreateBookingRequestParticipantsInfoOneOf,
  Slot,
  SlotResource,
  PhoneCall,
  CreateBookingRequestFlowControlSettings,
  V2CreateBookingResponse,
  V2CancelBookingRequest,
  CancelBookingRequestFlowControlSettings,
  V2CancelBookingResponse,
  V2RescheduleBookingRequest,
  V2RescheduleBookingRequestParticipantsInfoOneOf,
  RescheduleBookingRequestFlowControlSettings,
  V2RescheduleBookingResponse,
  V2ConfirmBookingRequest,
  V2ConfirmBookingResponse,
  V2DeclineBookingRequest,
  V2DeclineBookingResponse,
  V2UpdateNumberOfParticipantsRequest,
  V2UpdateNumberOfParticipantsRequestParticipantsInfoOneOf,
  V2UpdateNumberOfParticipantsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  WebhooksIdentificationData,
  WebhooksIdentificationDataIdOneOf,
  AccountInfo,
  ConfirmOrDeclineBookingRequest,
  ConfirmOrDeclineBookingResponse,
  BulkConfirmOrDeclineBookingRequest,
  BulkConfirmOrDeclineBookingRequestBookingDetails,
  BulkConfirmOrDeclineBookingResponse,
  BulkBookingResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  V1CancelBookingAnonymouslyRequest,
  V1CancelBookingAnonymouslyResponse,
  V1RescheduleBookingAnonymouslyRequest,
  V2Slot,
  SlotSlotResource,
  SlotLocation,
  V1RescheduleBookingAnonymouslyResponse,
  V1GetBookingAnonymouslyRequest,
  V1GetBookingAnonymouslyResponse,
  V1AllowedAnonymousActions,
  BookingFee,
  CancellationFee,
  Money,
  PolicyDetails,
  GetServiceAnonymouslyRequest,
  GetServiceAnonymouslyResponse,
  Service,
  Media,
  MediaItem,
  MediaItemItemOneOf,
  Category,
  Form,
  FormSettings,
  Payment,
  PaymentRateOneOf,
  FixedPayment,
  CommonMoney,
  CustomPayment,
  VariedPayment,
  SubscriptionPayment,
  FullUpfrontPayment,
  PaymentOptions,
  DiscountInfo,
  OnlineBooking,
  Conferencing,
  V2Location,
  V2LocationOptionsOneOf,
  CommonAddress,
  CommonAddressStreetOneOf,
  CommonStreetAddress,
  CommonAddressLocation,
  BusinessLocationOptions,
  CustomLocationOptions,
  BookingPolicy,
  PolicyDescription,
  LimitEarlyBookingPolicy,
  LimitLateBookingPolicy,
  BookAfterStartPolicy,
  CancellationPolicy,
  ReschedulePolicy,
  WaitlistPolicy,
  ParticipantsPolicy,
  ResourcesPolicy,
  CancellationFeePolicy,
  CancellationWindow,
  CancellationWindowFeeOneOf,
  SaveCreditCardPolicy,
  StaffSortingPolicy,
  StaffSortingPolicyOptionsOneOf,
  RankingOptions,
  CustomOptions,
  IntakeFormPolicy,
  Schedule,
  AvailabilityConstraints,
  V2Duration,
  DurationRange,
  DurationRangeConfigOneOf,
  HourlyConfig,
  DailyConfig,
  StaffMember,
  StaffMediaItem,
  StaffMediaItemItemOneOf,
  StaffMemberDetails,
  ResourceGroup,
  ResourceIds,
  ServiceResource,
  ServiceResourceSelectionOneOf,
  ResourceType,
  Slug,
  URLs,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  AddOnGroup,
  AddOnDetails,
  TaxableAddress,
  ServicesV2PhoneCall,
  GetAnonymousActionTokenRequest,
  GetAnonymousActionTokenResponse,
  CreateMultiServiceBookingRequest,
  CreateBookingFlowControlSettings,
  CreateMultiServiceBookingResponse,
  MultiServiceBooking,
  BookingResult,
  RescheduleMultiServiceBookingRequest,
  RescheduleBookingInfo,
  RescheduleBookingInfoParticipantsInfoOneOf,
  RescheduleBookingFlowControlSettings,
  RescheduleMultiServiceBookingResponse,
  BookingRescheduled,
  BookingRescheduledPreviousParticipantsInfoOneOf,
  IdentificationData,
  IdentificationDataIdOneOf,
  GetMultiServiceBookingAvailabilityRequest,
  GetMultiServiceBookingAvailabilityResponse,
  BookingPolicyViolations,
  BookingPolicySettings,
  GetMultiServiceBookingAvailabilityResponseBookingInfo,
  CancelMultiServiceBookingRequest,
  CancelBookingFlowControlSettings,
  CancelMultiServiceBookingResponse,
  BookingCanceled,
  MarkMultiServiceBookingAsPendingRequest,
  BookingInfo,
  MarkBookingAsPendingFlowControlSettings,
  MarkMultiServiceBookingAsPendingResponse,
  ConfirmMultiServiceBookingRequest,
  ConfirmBookingFlowControlSettings,
  ConfirmMultiServiceBookingResponse,
  BookingConfirmed,
  DeclineMultiServiceBookingRequest,
  DeclineBookingFlowControlSettings,
  DeclineMultiServiceBookingResponse,
  BookingDeclined,
  BulkGetMultiServiceBookingAllowedActionsRequest,
  BulkGetMultiServiceBookingAllowedActionsResponse,
  BulkCalculateAllowedActionsResult,
  AllowedActions,
  GetMultiServiceBookingRequest,
  GetMultiServiceBookingResponse,
  MultiServiceBookingMetadata,
  AddBookingsToMultiServiceBookingRequest,
  BookingIdAndRevision,
  AddBookingsToMultiServiceBookingResponse,
  RemoveBookingsFromMultiServiceBookingRequest,
  RemoveBookingsFromMultiServiceBookingResponse,
  BookingChanged,
  CreateBookingRequest,
  CreateBookingResponse,
  UpdateBookingRequest,
  UpdateBookingResponse,
  LegacyCreateBookingRequest,
  LegacyCreateBookingResponse,
  BulkUpdateBookingRequest,
  MaskedBooking,
  BulkUpdateBookingResponse,
  BulkCreateBookingRequest,
  CreateBookingInfo,
  BulkCreateBookingResponse,
  RescheduleBookingRequest,
  RescheduleBookingRequestParticipantsInfoOneOf,
  RescheduleBookingResponse,
  BulkRescheduleBookingRequest,
  BulkRescheduleBookingRequestBooking,
  SlotBookings,
  BulkRescheduleBookingResponse,
  BulkUpdateBookedScheduleRequest,
  BookingDetails,
  BulkUpdateBookedScheduleResponse,
  QueryBookingsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryBookingsResponse,
  PagingMetadataV2,
  CommonCursors,
  ConfirmRequest,
  ConfirmResponse,
  ConfirmBookingRequest,
  ConfirmBookingResponse,
  ConsistentQueryBookingsRequest,
  ConsistentQueryBookingsResponse,
  SetBookingSessionIdRequest,
  SetBookingSessionIdResponse,
  SetBookingSubmissionIdRequest,
  SetBookingSubmissionIdResponse,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  DeclineBookingRequest,
  DeclineBookingResponse,
  CancelBookingRequest,
  CancelBookingResponse,
  UpdateNumberOfParticipantsRequest,
  UpdateNumberOfParticipantsRequestParticipantsInfoOneOf,
  UpdateNumberOfParticipantsResponse,
  NumberOfParticipantsUpdated,
  NumberOfParticipantsUpdatedPreviousParticipantsInfoOneOf,
  BulkCalculateAllowedActionsRequest,
  BulkCalculateAllowedActionsResponse,
  GetSlotAvailabilityRequest,
  GetSlotAvailabilityResponse,
  SlotAvailability,
  WaitingList,
  AvailableResources,
  GetScheduleAvailabilityRequest,
  GetScheduleAvailabilityResponse,
  ScheduleAvailability,
  MarkBookingAsPendingRequest,
  MarkBookingAsPendingResponse,
  BookingMarkedAsPending,
  MigrationCheckIfClashesWithBlockedTimeRequest,
  MsidAndBookingId,
  MigrationCheckIfClashesWithBlockedTimeResponse,
  Clash,
  CountBookingsRequest,
  CountBookingsResponse,
  SearchBookingsRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  GroupByAggregation,
  GroupByAggregationKindOneOf,
  SearchDetails,
  SearchBookingsResponse,
  CursorPagingMetadata,
  Cursors,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  ScalarDateResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  GetAnonymousActionDetailsRequest,
  GetAnonymousActionDetailsResponse,
  AnonymousBookingUrls,
  CancelBookingAnonymouslyRequest,
  CancelBookingAnonymouslyResponse,
  RescheduleBookingAnonymouslyRequest,
  RescheduleBookingAnonymouslyResponse,
  GetBookingAnonymouslyRequest,
  GetBookingAnonymouslyResponse,
  AllowedActionsAnonymously,
  AllowedAnonymousActions,
  GetSchedulingUrlRequest,
  GetSchedulingUrlResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  BookingCanceledEnvelope,
  BookingConfirmedEnvelope,
  BookingCreatedEnvelope,
  BookingDeclinedEnvelope,
  BookingRescheduledEnvelope,
  BookingUpdatedEnvelope,
  BookingMarkedAsPendingEnvelope,
  BookingNumberOfParticipantsUpdatedEnvelope,
  ConfirmOrDeclineBookingOptions,
  BulkConfirmOrDeclineBookingOptions,
  BookingsRescheduleBookingAnonymouslyOptions,
  BookingsGetBookingAnonymouslyOptions,
  GetServiceAnonymouslyOptions,
  CreateMultiServiceBookingOptions,
  RescheduleMultiServiceBookingOptions,
  CancelMultiServiceBookingOptions,
  MarkMultiServiceBookingAsPendingOptions,
  ConfirmMultiServiceBookingOptions,
  DeclineMultiServiceBookingOptions,
  AddBookingsToMultiServiceBookingOptions,
  RemoveBookingsFromMultiServiceBookingOptions,
  CreateBookingOptions,
  BulkCreateBookingOptions,
  RescheduleBookingOptions,
  RescheduleBookingOptionsParticipantsInfoOneOf,
  ConfirmBookingOptions,
  UpdateExtendedFieldsOptions,
  DeclineBookingOptions,
  CancelBookingOptions,
  UpdateNumberOfParticipantsOptions,
  UpdateNumberOfParticipantsOptionsParticipantsInfoOneOf,
  MarkBookingAsPendingOptions,
} from './bookings-v2-booking-bookings.universal.js';
export {
  MultiServiceBookingTypeWithLiterals,
  ResourceTransparencyWithLiterals,
  LocationTypeWithLiterals,
  SelectionMethodWithLiterals,
  ValueTypeWithLiterals,
  BookingStatusWithLiterals,
  PaymentStatusWithLiterals,
  SelectedPaymentOptionWithLiterals,
  PlatformWithLiterals,
  ActorWithLiterals,
  IdentificationDataIdentityTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  LocationLocationTypeWithLiterals,
  V1RequestedFieldsWithLiterals,
  BookingFeeStatusWithLiterals,
  TriggerWithLiterals,
  RequestedFieldsWithLiterals,
  ServiceTypeWithLiterals,
  RateTypeWithLiterals,
  FrequencyTypeWithLiterals,
  FirstChargeDateTypeWithLiterals,
  AddOnPaymentOptionsWithLiterals,
  LocationTypeEnumLocationTypeWithLiterals,
  RankingOrderWithLiterals,
  SortingMethodTypeWithLiterals,
  TimingWithLiterals,
  CompletionRequirementWithLiterals,
  UnitTypeWithLiterals,
  TaxableAddressTypeWithLiterals,
  IdentityTypeWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  IntervalWithLiterals,
  NestedAggregationTypeWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  ConfirmOrDeclineBookingApplicationErrors,
  BulkConfirmOrDeclineBookingApplicationErrors,
  BookingsCancelBookingAnonymouslyApplicationErrors,
  BookingsRescheduleBookingAnonymouslyApplicationErrors,
  BookingsGetBookingAnonymouslyApplicationErrors,
  GetServiceAnonymouslyApplicationErrors,
  GetAnonymousActionTokenApplicationErrors,
  CreateMultiServiceBookingApplicationErrors,
  RescheduleMultiServiceBookingApplicationErrors,
  GetMultiServiceBookingAvailabilityApplicationErrors,
  CancelMultiServiceBookingApplicationErrors,
  MarkMultiServiceBookingAsPendingApplicationErrors,
  ConfirmMultiServiceBookingApplicationErrors,
  DeclineMultiServiceBookingApplicationErrors,
  AddBookingsToMultiServiceBookingApplicationErrors,
  RemoveBookingsFromMultiServiceBookingApplicationErrors,
  CreateBookingApplicationErrors,
  BulkCreateBookingApplicationErrors,
  RescheduleBookingApplicationErrors,
  ConfirmBookingApplicationErrors,
  SetBookingSubmissionIdApplicationErrors,
  UpdateExtendedFieldsApplicationErrors,
  DeclineBookingApplicationErrors,
  CancelBookingApplicationErrors,
  UpdateNumberOfParticipantsApplicationErrors,
  MarkBookingAsPendingApplicationErrors,
} from './bookings-v2-booking-bookings.universal.js';
